'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Calls a function passing properties values as arguments.
 * @example
 * // example with polished
 * import styled from 'styled-components'
 * import { darken } from 'polished'
 * import { withProp, prop } from 'styled-tools'
 *
 * const Button = styled.button`
 *   border-color: ${withProp(prop('theme.primaryColor', 'blue'), darken(0.5))};
 *   font-size: ${withProp('theme.size', size => `${size + 1}px`)};
 * `
 */
var withProp = function withProp(needle, fn) {
  return function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (typeof needle === 'function') {
      return fn(needle(props));
    }
    return fn((0, _get2.default)(props, needle));
  };
};
exports.default = withProp;


//////////////////
// WEBPACK FOOTER
// ./~/styled-tools/dist/cjs/withProp.js
// module id = 642
// module chunks = 97291517795586 114276838955818